var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-sync" }, [
    _c(
      "div",
      { staticClass: "sync-top" },
      [
        _c(
          "el-form",
          {
            staticClass: "demo-form-inline",
            attrs: { inline: true, model: _vm.formInline }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "用户编号：" } },
              [
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入用户编号" },
                  model: {
                    value: _vm.formInline.user,
                    callback: function($$v) {
                      _vm.$set(_vm.formInline, "user", $$v)
                    },
                    expression: "formInline.user"
                  }
                })
              ],
              1
            ),
            _c("el-form-item", { staticClass: "operate-btn" }, [
              _c("input", {
                staticClass: "btn btn-red search-btn",
                attrs: { type: "button", value: "查询" },
                on: { click: _vm.searchFn }
              }),
              _c("input", {
                staticClass: "btn btn-red reset-btn",
                attrs: { type: "button", value: "同步" },
                on: { click: _vm.syncFn }
              })
            ])
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "sync-body" }, [
      _c(
        "div",
        { staticClass: "now-mes" },
        [
          _c("div", { staticClass: "m-title" }, [_vm._v("现有用户信息")]),
          _c("user-detail")
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "new-mes" },
        [
          _c("div", { staticClass: "m-title" }, [_vm._v("最新用户信息")]),
          _c("user-detail")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }